import { render, staticRenderFns } from "./ImpresionListaAbordaje.vue?vue&type=template&id=683ba744&scoped=true&"
import script from "./ImpresionListaAbordaje.vue?vue&type=script&lang=js&"
export * from "./ImpresionListaAbordaje.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683ba744",
  null
  
)

export default component.exports